"use strict";import{tag as o}from"../custom-tag.js";export function videoReIcon({height:e=16,width:r=16,hidden:t=!1,title:l="Video re"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M3 21.225q.054 0 .1-.024l18-9a.225.225 0 0 0 0-.402l-18-9A.225.225 0 0 0 2.776 3v18a.225.225 0 0 0 .225.225m.225-17.861L20.497 12 3.225 20.636z"
      />
    </svg>
  `}
//# sourceMappingURL=videoRe.js.map
